import { render } from "./Categories.vue?vue&type=template&id=16c17589&ts=true"
import script from "./Categories.vue?vue&type=script&lang=ts"
export * from "./Categories.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__